module.exports = __webpack_public_path__ + "static/media/geoffpleiss_teaching_statement.e6e5dac3.pdf";